import React from 'react';
import { Button, Tooltip } from 'antd';
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { bindActionCreators } from 'redux';
import allVendorsIcon from '../../../assets/icons/all_vendors.svg';
import searchedVendorsIcon from '../../../assets/icons/searched_vendors.svg';
import collapseVendorTraceIcon from '../../../assets/icons/collapse_vendor_trace.svg';
import expandVendorTraceIcon from '../../../assets/icons/expand_vendor_trace.svg';
import {
    setIsCollapseChildren, setSearchByVendorNameMode,
} from '../../../actions/diagnose_vendor_trace_actions';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';

const VendorTraceZoom = ({ scaleValue, selectedVendorName, setIsCollapseChildren, setSearchByVendorNameMode, searchByVendorNameMode }) => {
    const fillColor = '#6565A9';
    return (
        <div className={'vendor-trace-zoom-container'}>
            {selectedVendorName && searchByVendorNameMode === 'allVendors' ?
                <Tooltip
                    placement="top"
                    overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                    title={() => {
                        return (
                            <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                                <div>Show all vendors</div>
                            </div>
                        ); 
}
                    }
                >
                    <Button
                        id={'show_all_vendors'}
                        icon={<SVG src={allVendorsIcon} />}
                        onClick={() => setSearchByVendorNameMode('searchedVendors')}
                    />
                </Tooltip> : null}
            {selectedVendorName && searchByVendorNameMode === 'searchedVendors' ?
                <Tooltip
                    placement="top"
                    overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                    title={() => {
                        return (
                            <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                                <div>Show only searched vendors</div>
                            </div>
                        ); 
}
                    }
                >
                    <Button
                        id={'show_only_searched_vendors'}
                        icon={<SVG src={searchedVendorsIcon} />}
                        onClick={() => setSearchByVendorNameMode('allVendors')}
                    />
                </Tooltip> : null}
            <Tooltip
                placement="top"
                overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                title={() => {
                    return (
                        <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                            <div>Zoom In</div>
                        </div>
                    ); 
}
                }
            >
                <Button id={'zoom_in'} icon={<ZoomInOutlined fill={fillColor} />} style={{ display: scaleValue >= 1 ? 'none' : 'inline-block' }} />
            </Tooltip>
            <Tooltip
                placement="top"
                overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                title={() => {
                    return (
                        <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                            <div>Zoom Out</div>
                        </div>
                    ); 
}
                }
            >
                <Button id={'zoom_out'} icon={<ZoomOutOutlined fill={fillColor} />} style={{ display: scaleValue < 1 ? 'none' : 'inline-block' }} />
            </Tooltip>
            <Tooltip
                placement="top"
                overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                title={() => {
                    return (
                        <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                            <div>Expand All</div>
                        </div>
                    ); 
}
                }
            >
                <Button
                    id={'expand_chart_button'}
                    icon={<SVG src={expandVendorTraceIcon} />}
                    onClick={() => setIsCollapseChildren(false)}
                    disabled={selectedVendorName}
                />
            </Tooltip>
            <Tooltip
                placement="top"
                overlayClassName="vendor-trace-zoom-buttons-tooltip-overlay"
                title={() => {
                    return (
                        <div className={'vendor-trace-zoom-buttons-tooltip-content'}>
                            <div>Collapse All</div>
                        </div>
                    ); 
}
                }
            >
                <Button
                    id={'collapse_chart_button'}
                    icon={<SVG src={collapseVendorTraceIcon} />}
                    onClick={() => setIsCollapseChildren(true)}
                    disabled={selectedVendorName}
                />
            </Tooltip>
        </div>

    );
};
const mapStateToProps = function (store) {
    return {
        searchByVendorNameMode: store.diagnoseVendorTraceState.getIn(['searchByVendorNameMode', 'value']),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setIsCollapseChildren,
        setSearchByVendorNameMode,
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(VendorTraceZoom);
